var _path, _path2, _path3, _path4, _mask, _g, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLloydsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    fill: "none",
    "data-testid": "LloydsSVG",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 1h56.274v56.349H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 1h56.274v56.349H1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 1h56.274v56.349H1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.137 57.349c15.54 0 28.137-12.614 28.137-28.175C57.274 13.614 44.676 1 29.137 1 13.597 1 1 13.614 1 29.174 1 44.734 13.597 57.35 29.137 57.35z",
    fill: "#811963"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 57,
    height: 57
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.137 57.349c15.54 0 28.137-12.614 28.137-28.175C57.274 13.614 44.676 1 29.137 1 13.597 1 1 13.614 1 29.174 1 44.734 13.597 57.35 29.137 57.35z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1.973-1.36h61.501v61.038h-61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.973 59.678H59.53v-30.52H-1.973v30.52z",
    fill: "#17AE65"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.973 29.165H59.53V-1.36H-1.973v30.525z",
    fill: "#1967BB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1.973 59.678h61.501v-30.52h-61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1.973 59.678h61.501v-30.52h-61.5z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 29,
    width: 62,
    height: 31
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.973 59.678H59.53v-30.52H-1.973v30.52z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-17.05 87.324h91.657V1.514H-17.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.05 26.583L52.335 1.514l2.453 6.684-69.391 25.064",
    fill: "#BAE6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.604 33.262l69.39-25.064.133.369-69.385 25.069",
    fill: "#BAE6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.466 33.636l69.385-25.07.136.369-69.384 25.069",
    fill: "#B8E6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.329 34.004l69.384-25.07.138.375-69.39 25.063",
    fill: "#B7E5C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.197 34.371L55.193 9.31l.137.367-69.39 25.07",
    fill: "#B6E5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.06 34.745L55.33 9.676l.132.368-69.383 25.07",
    fill: "#B4E4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.921 35.113l69.383-25.069.138.374-69.384 25.064",
    fill: "#B3E4BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.784 35.483L55.6 10.418l.138.37-69.391 25.068",
    fill: "#B2E3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.653 35.856l69.39-25.069.132.368-69.385 25.07",
    fill: "#B1E3BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.516 36.224l69.385-25.07.138.375-69.385 25.063",
    fill: "#AFE3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.378 36.592l69.385-25.063.137.368-69.39 25.069",
    fill: "#AEE2B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.246 36.966l69.39-25.07.131.374-69.383 25.064",
    fill: "#ADE2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.108 37.334L56.275 12.27l.138.368-69.384 25.065",
    fill: "#ABE1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.97 37.703l69.383-25.065.138.37-69.39 25.069",
    fill: "#AAE1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.839 38.077l69.39-25.07.138.374-69.39 25.063",
    fill: "#A9E0B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.701 38.444l69.39-25.063.131.368-69.385 25.07",
    fill: "#A8E0B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.565 38.812L56.82 13.75l.138.368-69.391 25.069",
    fill: "#A6DFB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.433 39.186l69.391-25.07.138.375-69.391 25.063",
    fill: "#A5DFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.295 39.554l69.39-25.063.13.367-69.383 25.07",
    fill: "#A4DEB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.158 39.928l69.384-25.07.138.368-69.384 25.07",
    fill: "#A3DEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.02 40.297l69.384-25.07.138.375-69.39 25.063",
    fill: "#A1DEB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.888 40.665l69.39-25.063.131.367-69.383 25.07",
    fill: "#A0DDAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.75 41.038L57.633 15.97l.138.368-69.383 25.07",
    fill: "#9FDDAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.612 41.406L57.77 16.337l.138.374-69.391 25.063",
    fill: "#9DDCAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.482 41.774l69.39-25.063.133.368-69.385 25.069",
    fill: "#9CDCAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.345 42.148l69.386-25.07.137.369-69.385 25.069",
    fill: "#9BDBAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.207 42.516l69.385-25.07.137.374-69.39 25.065",
    fill: "#9ADBAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.075 42.885l69.39-25.065.137.37-69.39 25.069",
    fill: "#98DAA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.937 43.259l69.39-25.07.131.369-69.383 25.069",
    fill: "#97DAA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.8 43.627l69.384-25.07.138.374-69.39 25.063",
    fill: "#96D9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.662 43.994l69.384-25.063.138.368-69.39 25.07",
    fill: "#94D9A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.53 44.368L58.86 19.3l.131.374-69.385 25.063",
    fill: "#93D9A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.394 44.736l69.385-25.063.138.368-69.385 25.064",
    fill: "#92D8A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.256 45.105l69.385-25.064.136.369-69.39 25.07",
    fill: "#91D8A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.124 45.479l69.39-25.07.131.375-69.383 25.063",
    fill: "#8FD7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.986 45.847l69.383-25.063.138.368L-9.85 46.22",
    fill: "#8ED7A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.849 46.22l69.384-25.068.138.367-69.39 25.07",
    fill: "#8DD6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.717 46.589l69.39-25.07.137.374-69.39 25.063",
    fill: "#8BD6A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.58 46.956l69.39-25.063.132.368-69.385 25.07",
    fill: "#8AD5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.443 47.33l69.385-25.069.138.37-69.391 25.068",
    fill: "#89D59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.311 47.7l69.39-25.07.139.374-69.391 25.063",
    fill: "#87D49E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.173 48.067l69.39-25.063.132.368-69.385 25.069",
    fill: "#86D49D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.036 48.44L60.35 23.373l.137.368-69.384 25.069",
    fill: "#85D49C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.898 48.809l69.384-25.07.138.374-69.39 25.063",
    fill: "#84D39B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.766 49.177l69.39-25.063.131.367-69.383 25.07",
    fill: "#82D39B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.628 49.55l69.383-25.069.138.368-69.384 25.07",
    fill: "#81D29A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.49 49.92l69.383-25.07.138.374-69.39 25.064",
    fill: "#80D299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.359 50.287l69.39-25.063.132.368-69.386 25.07",
    fill: "#7FD198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.223 50.661l69.385-25.069.138.374-69.385 25.063",
    fill: "#7DD197"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.085 51.03L61.3 25.965l.137.368-69.39 25.063",
    fill: "#7CD197"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.953 51.397l69.39-25.063.137.367-69.39 25.07",
    fill: "#7BD096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.815 51.77l69.39-25.068.131.373L-7.678 52.14",
    fill: "#79D095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.677 52.14l69.383-25.065.138.37-69.39 25.069",
    fill: "#78CF94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.546 52.514l69.39-25.07.138.369-69.39 25.069",
    fill: "#77CF93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.408 52.882l69.39-25.07.131.374L-7.272 53.25",
    fill: "#76CE93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.272 53.25l69.385-25.064.138.368-69.385 25.07",
    fill: "#74CE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.134 53.623l69.385-25.069.138.368L-7.002 53.99",
    fill: "#73CD91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.002 53.991l69.39-25.07.131.375-69.384 25.063",
    fill: "#72CD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.864 54.359l69.383-25.063.138.367-69.384 25.071",
    fill: "#71CD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.727 54.734l69.384-25.07.138.369-69.39 25.069",
    fill: "#6FCC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.595 55.102l69.39-25.07.137.375-69.39 25.063",
    fill: "#6ECC8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.457 55.47l69.39-25.063.131.367-69.383 25.07",
    fill: "#6DCB8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.32 55.843l69.384-25.069.138.368-69.391 25.07",
    fill: "#6BCB8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.19 56.211l69.392-25.069.138.374-69.392 25.063",
    fill: "#6ACA8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.052 56.579L63.34 31.516l.131.368-69.385 25.069",
    fill: "#69CA8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.914 56.953l69.385-25.07.137.37-69.384 25.07",
    fill: "#68C98A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.776 57.322l69.384-25.069.138.374-69.39 25.063",
    fill: "#66C98A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.644 57.69l69.39-25.063.131.368-69.383 25.069",
    fill: "#65C989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.506 58.064l69.383-25.07.138.374L-5.37 58.431",
    fill: "#63C888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.369 58.431l69.384-25.063.138.368L-5.237 58.8",
    fill: "#63C888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.237 58.8l69.39-25.064.131.368L-5.1 59.174",
    fill: "#61C787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.1 59.173l69.384-25.069.138.374-69.385 25.064",
    fill: "#60C786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.963 59.542l69.385-25.064.138.37-69.391 25.068",
    fill: "#5EC685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.831 59.916L64.56 34.847l.136.368-69.39 25.07",
    fill: "#5DC685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.693 60.284l69.39-25.069.13.374-69.383 25.063",
    fill: "#5CC584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.556 60.652l69.384-25.063.138.367-69.39 25.07",
    fill: "#5BC583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.424 61.026l69.39-25.07.138.368-69.39 25.07",
    fill: "#59C583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.286 61.393l69.39-25.069.131.374-69.383 25.065",
    fill: "#58C482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.148 61.763l69.383-25.065.138.37-69.385 25.069",
    fill: "#57C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.012 62.137l69.385-25.07.138.368-69.391 25.07",
    fill: "#55C380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.88 62.504l69.39-25.069.132.374-69.385 25.063",
    fill: "#54C380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.743 62.872L65.642 37.81l.137.368-69.384 25.069",
    fill: "#53C37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.605 63.246l69.384-25.07.138.369-69.39 25.069",
    fill: "#52C27F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.473 63.614l69.39-25.07.131.375-69.383 25.063",
    fill: "#50C27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.335 63.982l69.383-25.063.138.367-69.384 25.07",
    fill: "#4FC17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.198 64.357l69.384-25.07.138.375-69.39 25.063",
    fill: "#4EC17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.066 64.725l69.39-25.063.138.367L-2.93 65.092",
    fill: "#4DC07C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.93 65.093l69.392-25.064.131.368-69.385 25.07",
    fill: "#4BC07B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.792 65.466l69.385-25.069.137.374-69.384 25.063",
    fill: "#4ABF7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.654 65.834l69.383-25.063.138.368-69.39 25.069",
    fill: "#49BF7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.522 66.208l69.39-25.07.131.369-69.384 25.07",
    fill: "#47BF79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.385 66.577L67 41.507l.138.375-69.384 25.063",
    fill: "#46BE79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.247 66.945l69.384-25.063.138.368-69.39 25.069",
    fill: "#45BE78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.115 67.319l69.39-25.07.131.368-69.385 25.07",
    fill: "#44BD78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.979 67.687l69.385-25.07.138.374L-1.84 68.054",
    fill: "#42BD77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.84 68.054l69.384-25.063.138.368L-1.71 68.43",
    fill: "#41BC76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.71 68.428L67.683 43.36l.136.368-69.39 25.069",
    fill: "#3FBC76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.572 68.796l69.39-25.07.132.375-69.384 25.064",
    fill: "#3EBB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.434 69.165L67.95 44.101l.138.369-69.39 25.07",
    fill: "#3DBB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.302 69.54l69.39-25.07.138.368-69.39 25.069",
    fill: "#3CBB74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.164 69.907l69.39-25.07.131.375-69.383 25.063",
    fill: "#3ABA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.026 70.275l69.383-25.063.138.367L-.89 70.65",
    fill: "#39BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.89 70.648L68.495 45.58l.138.374L-.758 71.016",
    fill: "#38B972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.759 71.016l69.392-25.063.131.368L-.62 71.385",
    fill: "#37B972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.62 71.386L68.763 46.32l.137.37L-.483 71.758",
    fill: "#35B971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.483 71.76l69.384-25.07.137.374-69.39 25.063",
    fill: "#34B871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.351 72.127l69.39-25.063.131.368L-.213 72.495",
    fill: "#33B870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.213 72.495L69.17 47.432l.138.368L-.076 72.869",
    fill: "#31B770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.076 72.869l69.384-25.07.138.375L.056 73.237",
    fill: "#30B76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.056 73.237l69.39-25.063.138.367L.192 73.611",
    fill: "#2FB66F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.192 73.61l69.392-25.069.131.37L.33 73.98",
    fill: "#2EB66E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.33 73.98l69.385-25.07.138.374L.468 74.347",
    fill: "#2CB66D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.468 74.347l69.385-25.062.136.367L.6 74.722",
    fill: "#2BB56D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6 74.721l69.39-25.069.13.368L.738 75.09",
    fill: "#2AB56C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.737 75.089l69.384-25.07.138.375L.875 75.457",
    fill: "#29B46C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.875 75.457L70.26 50.394l.138.367-69.39 25.07",
    fill: "#27B46B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.007 75.83l69.39-25.068.131.367L1.145 76.2",
    fill: "#26B36B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.145 76.2l69.383-25.07.138.375L1.281 76.568",
    fill: "#25B36A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.281 76.568l69.385-25.063.138.368L1.413 76.942",
    fill: "#23B36A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.413 76.942l69.39-25.07.137.368L1.55 77.31",
    fill: "#22B269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.55 77.31l69.39-25.07.132.374L1.688 77.677",
    fill: "#21B269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.688 77.677l69.384-25.063.138.368L1.82 78.05",
    fill: "#20B168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82 78.05l69.39-25.068.137.374-69.39 25.063",
    fill: "#1EB168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.958 78.419l69.39-25.063.131.368L2.095 78.788",
    fill: "#1DB067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.095 78.788L71.48 53.724l.138.369L2.232 79.162",
    fill: "#1CB067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.232 79.162l69.385-25.07.138.375L2.363 79.53",
    fill: "#1AB066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.363 79.53l69.392-25.063.131.367-69.385 25.07",
    fill: "#19AF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.501 79.903l69.385-25.069.138.368L2.64 80.272",
    fill: "#18AF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.639 80.271l69.385-25.069.136.374L2.77 80.639",
    fill: "#17AE65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77 80.639l69.39-25.063 2.447 6.68L5.224 87.323",
    fill: "#17AE65"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1.973 29.165h61.501V-1.36h-61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1.973 29.165h61.501V-1.36h-61.5z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 62,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.973 29.165H59.53V-1.36H-1.973v30.525z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-17.05 56.811h91.657v-85.81H-17.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.05-3.93l69.384-25.069 2.453 6.684-69.391 25.064",
    fill: "#1967BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.604 2.75l69.39-25.065.133.37-69.385 25.068",
    fill: "#1967BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.466 3.123l69.385-25.069.136.368L-14.33 3.49",
    fill: "#1B68BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.329 3.491l69.384-25.07.138.375-69.39 25.063",
    fill: "#1C69BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.197 3.859l69.39-25.063.137.367-69.39 25.07",
    fill: "#1E69BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.06 4.233l69.39-25.07.132.368-69.383 25.07",
    fill: "#1F6ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.921 4.6l69.383-25.069.138.374-69.384 25.063",
    fill: "#206ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.784 4.968L55.6-20.095l.138.368-69.391 25.07",
    fill: "#226BBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.653 5.344l69.39-25.071.132.37L-13.516 5.71",
    fill: "#236BBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.516 5.711L55.87-19.358l.138.374-69.385 25.063",
    fill: "#246CBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.378 6.079l69.385-25.063.137.368-69.39 25.069",
    fill: "#266DBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.246 6.453l69.39-25.07.131.375L-13.108 6.82",
    fill: "#276DBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.108 6.82l69.383-25.062.138.367-69.384 25.063",
    fill: "#296EC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.97 7.188l69.383-25.063.138.368-69.39 25.07",
    fill: "#2A6FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.839 7.562l69.39-25.069.138.374-69.39 25.065",
    fill: "#2B6FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.701 7.932l69.39-25.065.131.37-69.385 25.068",
    fill: "#2D70C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.565 8.305L56.82-16.764l.138.368-69.391 25.07",
    fill: "#2E71C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.433 8.673l69.391-25.069.138.374L-12.295 9.04",
    fill: "#3071C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.295 9.041l69.39-25.063.13.368-69.383 25.069",
    fill: "#3172C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.158 9.415l69.384-25.07.138.368-69.384 25.07",
    fill: "#3373C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.02 9.783l69.384-25.07.138.374-69.39 25.065",
    fill: "#3473C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.888 10.152l69.39-25.065.131.37-69.383 25.069",
    fill: "#3674C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.75 10.526l69.383-25.07.138.368-69.383 25.07",
    fill: "#3775C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.612 10.893L57.77-14.175l.138.374-69.391 25.063",
    fill: "#3976C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.482 11.261l69.39-25.063.133.368-69.385 25.069",
    fill: "#3A76C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.345 11.635l69.386-25.069.137.368-69.385 25.069",
    fill: "#3B77C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.207 12.003l69.385-25.07.137.374-69.39 25.065",
    fill: "#3D78C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.075 12.372l69.39-25.064.137.369-69.39 25.069",
    fill: "#3E78C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.937 12.746l69.39-25.07.131.369-69.383 25.069",
    fill: "#4079C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.8 13.114l69.384-25.07.138.375-69.39 25.063",
    fill: "#417AC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.662 13.482l69.384-25.064.138.368-69.39 25.07",
    fill: "#437BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.53 13.855l69.39-25.069.131.374-69.385 25.063",
    fill: "#447BC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.394 14.223L58.991-10.84l.138.368-69.385 25.063",
    fill: "#457CC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.256 14.59l69.385-25.062.136.368-69.39 25.07",
    fill: "#477DC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.124 14.966l69.39-25.07.131.375-69.383 25.063",
    fill: "#497EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.986 15.334L59.397-9.729l.138.368L-9.85 15.708",
    fill: "#4A7FC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.849 15.708l69.384-25.07.138.369-69.39 25.069",
    fill: "#4C7FCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.717 16.076l69.39-25.07.137.374-69.39 25.063",
    fill: "#4D80CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.58 16.443L59.81-8.62l.132.368-69.385 25.07",
    fill: "#4F81CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.443 16.817L59.942-8.252l.138.368-69.391 25.07",
    fill: "#5082CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.311 17.187l69.39-25.071.139.375-69.391 25.063",
    fill: "#5283CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.173 17.554l69.39-25.063.132.368-69.385 25.07",
    fill: "#5384CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.036 17.928L60.35-7.14l.137.368-69.384 25.069",
    fill: "#5585CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.898 18.296l69.384-25.07.138.375-69.39 25.063",
    fill: "#5685CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.766 18.664L60.624-6.4l.131.368-69.383 25.069",
    fill: "#5886CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.628 19.038l69.383-25.07.138.368-69.384 25.07",
    fill: "#5987CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.49 19.405L60.892-5.664l.138.374-69.39 25.065",
    fill: "#5B88CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.359 19.775L61.031-5.29l.132.37-69.386 25.068",
    fill: "#5C89CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.223 20.148L61.162-4.92l.138.374-69.385 25.063",
    fill: "#5E8ACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.085 20.516L61.3-4.547l.137.368-69.39 25.063",
    fill: "#5F8BD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.953 20.884l69.39-25.063.137.368-69.39 25.069",
    fill: "#618CD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.815 21.258l69.39-25.07.131.375-69.384 25.063",
    fill: "#628CD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.677 21.626L61.706-3.437l.138.367L-7.546 22",
    fill: "#648DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.546 22l69.39-25.07.138.37-69.39 25.069",
    fill: "#668ED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.408 22.369l69.39-25.07.131.375-69.385 25.063",
    fill: "#678FD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.272 22.736L62.113-2.326l.138.368-69.385 25.07",
    fill: "#6990D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.134 23.11L62.251-1.959l.138.368-69.391 25.07",
    fill: "#6B91D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.002 23.478L62.388-1.59l.131.374-69.384 25.063",
    fill: "#6C92D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.864 23.846L62.518-1.217l.138.368L-6.727 24.22",
    fill: "#6E93D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.727 24.22L62.657-.85l.138.37-69.39 25.07",
    fill: "#6F94D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.595 24.589l69.39-25.07.137.375-69.39 25.063",
    fill: "#7195D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.457 24.957L62.933-.106l.131.368L-6.319 25.33",
    fill: "#7296D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.32 25.33L63.065.263l.138.367L-6.19 25.7",
    fill: "#7497D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.19 25.698L63.203.63l.138.374-69.392 25.063",
    fill: "#7598D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.052 26.066L63.34 1.003l.131.368-69.385 25.07",
    fill: "#7799D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.914 26.44L63.471 1.37l.137.375-69.384 25.064",
    fill: "#799AD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.776 26.81L63.608 1.744l.138.37-69.39 25.062",
    fill: "#7A9BD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.644 27.177l69.39-25.063.131.368L-5.506 27.55",
    fill: "#7C9CD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.506 27.55L63.877 2.483l.138.374L-5.37 27.919",
    fill: "#7D9DD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.369 27.919L64.015 2.856l.138.367-69.39 25.063",
    fill: "#7F9ED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.237 28.287l69.39-25.063.131.367L-5.1 28.661",
    fill: "#819FD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.1 28.66L64.283 3.591l.138.374-69.385 25.063",
    fill: "#82A0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.963 29.028L64.422 3.965l.138.368-69.391 25.07",
    fill: "#84A2DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.831 29.404L64.56 4.332l.136.37-69.39 25.068",
    fill: "#86A3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.693 29.771l69.39-25.069.13.374-69.383 25.063",
    fill: "#87A4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.556 30.139L64.828 5.076l.138.368-69.39 25.069",
    fill: "#89A5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.424 30.513l69.39-25.07.138.369-69.39 25.069",
    fill: "#8BA6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.286 30.88l69.39-25.068.131.373-69.383 25.063",
    fill: "#8CA7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.148 31.248L65.235 6.185l.138.368-69.385 25.07",
    fill: "#8EA8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.012 31.624l69.385-25.07.138.368-69.391 25.07",
    fill: "#90A9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.88 31.992l69.39-25.07.132.374L-3.743 32.36",
    fill: "#91AADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.743 32.36L65.642 7.295l.137.368-69.384 25.07",
    fill: "#93ACDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.605 32.733L65.78 7.664l.138.368L-3.474 33.1",
    fill: "#95ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.473 33.101l69.39-25.07.137.375-69.39 25.063",
    fill: "#96AEE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.335 33.469l69.39-25.063.131.367-69.384 25.07",
    fill: "#98AFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.198 33.843l69.384-25.07.138.374-69.39 25.065",
    fill: "#9AB0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.066 34.212l69.39-25.065.138.37L-2.93 34.58",
    fill: "#9BB1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.93 34.58L66.462 9.517l.131.367-69.385 25.07",
    fill: "#9DB3E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.792 34.953L66.593 9.884l.137.374-69.384 25.063",
    fill: "#9FB4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.654 35.321l69.383-25.063.138.368-69.39 25.07",
    fill: "#A0B5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.522 35.695l69.39-25.069.131.368-69.384 25.069",
    fill: "#A2B6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.385 36.063L67 10.993l.138.375-69.384 25.064",
    fill: "#A4B7E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.247 36.432l69.384-25.064.138.369-69.39 25.069",
    fill: "#A5B9E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.115 36.806l69.39-25.07.131.369-69.385 25.069",
    fill: "#A7BAE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.979 37.174l69.385-25.07.138.375L-1.84 37.541",
    fill: "#A9BBE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.84 37.542l69.384-25.064.138.368-69.391 25.07",
    fill: "#ABBCE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.71 37.915l69.392-25.069.136.368-69.39 25.07",
    fill: "#ACBEE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.572 38.283l69.39-25.069.132.374-69.384 25.065",
    fill: "#AEBFE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.434 38.652L67.95 13.588l.138.37-69.39 25.068",
    fill: "#B0C0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.302 39.026l69.39-25.069.138.368-69.39 25.069",
    fill: "#B1C1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.164 39.394l69.39-25.069.131.374-69.383 25.063",
    fill: "#B3C3E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.026 39.762l69.383-25.063.138.367L-.89 40.136",
    fill: "#B5C4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.89 40.136l69.385-25.07.138.374L-.758 40.503",
    fill: "#B7C5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.759 40.503L68.633 15.44l.131.368L-.62 40.871",
    fill: "#B8C7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.62 40.871l69.384-25.063.137.368-69.384 25.07",
    fill: "#BAC8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.483 41.247l69.384-25.071.137.375-69.39 25.063",
    fill: "#BCC9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.351 41.614l69.39-25.063.131.368L-.213 41.99",
    fill: "#BECBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.213 41.982L69.17 16.92l.138.368L-.076 42.356",
    fill: "#BFCCEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.076 42.356l69.384-25.07.138.375L.056 42.724",
    fill: "#C1CDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.056 42.724l69.39-25.063.138.367L.192 43.098",
    fill: "#C3CFED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.192 43.098l69.392-25.07.131.368L.33 43.466",
    fill: "#C5D0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.33 43.465l69.385-25.069.138.374L.468 43.835",
    fill: "#C6D1EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.468 43.835L69.853 18.77l.136.37L.6 44.208",
    fill: "#C8D3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6 44.209l69.39-25.07.13.368L.738 44.577",
    fill: "#CAD4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.737 44.576l69.384-25.069.138.374L.875 44.944",
    fill: "#CCD5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.875 44.944L70.26 19.881l.138.368-69.39 25.069",
    fill: "#CED7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.007 45.318l69.39-25.07.131.369L1.145 45.686",
    fill: "#CFD8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.145 45.686l69.383-25.07.138.374L1.281 46.055",
    fill: "#D1DAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.281 46.055L70.666 20.99l.138.37L1.413 46.429",
    fill: "#D3DBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.413 46.429l69.39-25.07.137.368-69.39 25.07",
    fill: "#D5DDF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.55 46.797l69.39-25.07.132.374L1.688 47.164",
    fill: "#D7DEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.688 47.164l69.384-25.063.138.368L1.82 47.54",
    fill: "#D8DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82 47.538L71.21 22.47l.137.374-69.39 25.063",
    fill: "#DAE1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.958 47.906l69.39-25.063.131.368L2.095 48.275",
    fill: "#DCE2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.095 48.275L71.48 23.211l.138.369L2.232 48.649",
    fill: "#DEE4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.232 48.65l69.385-25.07.138.374L2.363 49.017",
    fill: "#E0E5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.363 49.017l69.392-25.063.131.367-69.385 25.07",
    fill: "#E2E7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.501 49.39l69.385-25.068.138.367L2.64 49.76",
    fill: "#E3E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.639 49.758L72.024 24.69l.136.374L2.77 50.126",
    fill: "#E5EAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77 50.126l69.39-25.063 2.447 6.68L5.224 56.81",
    fill: "#E5EAF8"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.627 15.061c.217.071.252.033.252-.23-.005-.47.242-.185.68-.185.733 0 .95.03 1.57.424.507.314.583.658 1.18.658.162 0 .182-.26.352-.26.315 0 .315.37.315.696 0 .31-.289.532-.289.844 0 .225 1.01.242 1.141.419.187.243.119.604.409.684.157.037.259-.068.416 0 .136.054.158.247.107.41-.052.164-.15.294-.396.492-.205.159-.485.192-.583.264-.093.07-.022.247.03.33.332.546.328.567.489.71.158.134.46.251.498.533.021.154-.094.255-.353.33-.293.084-.422.337-.31.588.097.24.075.402.122.658.038.193.21.265.21.462 0 .248-.167.449-.401.449-.213 0-.17-.377-.383-.377a.179.179 0 0 0-.069.016c-.37.218.686 1.09-.046 1.405-.358.155-.12.6.319.918.077-.012.404-.066.941-.083.617-.018.677 0 1.068-.034.395-.033.527-.11 1.111-.11.813 0 1.404.463 1.949 1.092.672.776 1.072 1.04 1.834 1.716.766.683 1.132 1.173 1.949 1.782.655.486 1.345.817 1.345 1.657 0 .31-.38.365-.672.365-.614 0-1.094-.017-1.507-.483-.213-.247.085-.595-.093-.868-.132-.202-.397-.072-.6-.189-.363-.205-.209-.255-.47-.583-.616-.776-1.152-1.35-1.922-1.954-.587-.457-1.243-.882-1.524-.86-.208.02-.26.02-.464.02-.783 0-1.17.537-1.89.844a4.462 4.462 0 0 1-1.106.33l-.093.13.642-.041c.63 0 .966-.222 1.596-.222.634 0 .877.583 1.183 1.153.515.948.975 1.401 1.391 2.408.341.826.558 1.304 1.018 2.063.421.688.792 1.116.792 1.925 0 .269-.022.63-.277.63-.455 0-.669-.28-1.069-.483-.293-.151-.646-.235-.646-.578 0-.403.323-.584.323-.986 0-.26-.391-.214-.463-.457-.239-.751-.192-.802-.545-1.497-.366-.718-.97-1.695-1.533-2.253-.174-.172-.127-.268-.51-.268a1.39 1.39 0 0 0-.566.12c-.71.315-1.12.76-1.673 1.109-.531.315-.634.456-1.48.725-.652.193-.758-.188-1.422-.038-.609.13-1.455.764-2.154.885-.4.118-.804.189-1.676.323-.724.11-2.043.231-2.992.101-1.842-.247-2.702-.34-2.808-.29-.154.42-.48 1.016-.664 1.309-.54.835-1.129 1.573-2.018 1.976-.719.319-.935.738-.719 1.514.123.428.157.525.422.935.6.94.31.49.864 1.465.416.72 1.157 1.971 1.813 2.462.616.46 1.31.7 1.31 1.484 0 .331-.486.134-.8.134-.366 0-.71.202-.932-.088-.252-.327-.03-.734-.294-1.053-.186-.23-.494-.105-.719-.301-.438-.403-.183-.592-.514-1.104-.92-1.439-1.312-1.988-2.099-3.01-.425-.555-.966-.815-.966-1.528 0-.864.893-1.015.855-1.879-.85.46-.616.553-1.616.75-.12.025-.447.072-.618.11-.128.02-.501.269-.66.41-.374.332-.62.68-.62 1.192l-.094 1.191-.073 2.495c.14.764.358.886.822 1.486.34.435.8.616.8 1.178 0 .412-.575.31-.97.31-.333 0-.648.144-.843-.133-.196-.273-.073-.533-.128-.873-.11-.718-.94-.747-.872-1.46.149-1.54.17-3.284.17-3.284l.072-2.533c-.067-1.12.844-1.05 1.507-2 .388-.555.272-.303.493-.735.217-.432.183-.738.167-.994-.026-.331-.34-1.015-.128-2.42.149-.943.54-1.27.923-1.757.018-.022.018-.068-.055-.068-.685 0-.464.567-.842.567-.15 0-.315-.105-.315-.273 0-.147.055-.248.101-.352.044-.1-.092-.122-.17-.122-.28 0-.382.327-.659.327-.196 0-.396-.134-.396-.37 0-.255.06-.31.272-.578.218-.26-.097-.121-.097-.121-.32.176-.494.34-.716.658-.11.168-.17.37-.353.37-.196 0-.178-.408-.375-.408-.174 0-.22.244-.22.45 0 .704.535.913 1.064 1.3.71.51 1.157 1.14 1.157 2.143 0 .998-.514 1.971-1.336 1.971h-.473c-.323 0-.757.02-.757.416 0 .159.123.2.179.348.085.218-.188.44-.396.461a.784.784 0 0 1-.558-.189c-.297-.268-.383-.583-.383-1.036 0-.516.239-.864.613-1.095.387-.23.869-.33.869-.856 0-.356-.256-.494-.507-.674-.587-.429-.949-.65-1.442-1.23-.639-.73-.809-1.551-.809-2.554 0-1.85 1.226-3.268 2.86-3.268.416 0 1.383-.075 2.182 1.104.303.445.498.549.775.918.17.231.58.491.817.654.132.084.676.31 1.047.352 0 0 .69-.418 1.167-.581.514-.202 1.165-.277 1.719-.257 1.472.068 2.016.264 3.106.382 1.093.113 2.54-.42 3.779-1.23.46-.297.656-.376 1.085-.733.435-.365.498-.554.877-1.1.204-.3.514-.955.66-1.29.153-.362.36-.782.396-1.146.03-.34.047-.596-.27-.596-.531 0-.995.495-1.505.995-.35.335.17.473-.575.889-.268.147-.574-.101-.88-.101-.583 0-.844-.688-.844-1.292 0-.306.248-.411.38-.68.297-.578.272-.792.557-1.384.188-.398.49-.662.472-.935-.004-.117-.085-.167-.085-.285 0-.575.783-.973.783-1.548 0-.343-.37-.482-.464-.746-.093-.26-.02-.327-.02-.327.038-.042.071-.068.11-.068.327 0 .442.323.727.5.005-.038.013-.11.013-.155 0-.253-.11-.353-.11-.605 0-.159-.026-.394.127-.394.191 0 .183.273.336.394.221.176.438.156.677.306.302.198.481.517.587.554z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.082 26.164c.234-.022.288-.286.446-.49.38-.5.672-.907 1.239-.907.085 0 .187.059.187.167 0 .248-.307.282-.307.533 0 .097.038.206.12.206.17 0 .234-.172.391-.248.357-.184.591-.243.983-.243.264 0 .426.009.68.08.099.024.269.114.269-.013 0-.315-.068-.453-.264-.713l-.072-.084c-.536-.645-1.469-.7-1.703-.67-1.034.142-1.625.91-2.068 2.054-.11.336-.013.34.098.328zM17.133 42.744c0 .302.133.453.187.743.161 0 .261-.03.422-.005v-.255c-.146-.277-.188-.495-.422-.66h-.149c-.011.068-.038.106-.038.177zM24.53 42.585c.147.288.147.524.34.788h.42v-.13a3.424 3.424 0 0 0-.59-.793c-.065.05-.099.088-.17.135zM43.287 35.215c.123.063.2.122.32.188l.107-.02c.003-.105.02-.18.01-.299-.03-.352-.089-.666-.337-.796-.043.356.016.6-.1.927zM47.224 31.302c.175-.013.184.012.383-.038a.365.365 0 0 0 .21-.114c-.04-.1-.052-.18-.108-.28-.174-.306-.366-.558-.714-.541.25.457.114 1.006.23.973zM35.99 19.805c-.095 1.648-.69 2.429-1.64 3.657-.238.31-.382.495-.63.79-.11.125-.254.18-.254.347 0 .231.225.293.42.394.444.24.733.353 1.137.659.575.428.762.99.762 1.728 0 .641-.256.99-.256 1.64 0 .07-.008.251.085.172.58-.902 1.222-1.384 1.222-2.471 0-.616-.097-1.12-.588-1.463-.255-.177-.616-.185-.634-.504-.016-.381.252-.88.422-1.292.239-.566.74-2.152.74-3.666 0-1.753-.974-3.137-2.574-3.69-.468-.176-.481.046-.311.121.357.264 1.154.231 1.894 1.967.153.361.234 1.07.204 1.611zM27.086 28.668c1.37-.147 1.567-.458 1.826-1.48.047-.186.132-.366.217-.538.162-.323.366-.545.558-.759.208-.23.386-.403.587-.713.085-.134.111-.251 0-.21-.14.105-.6.424-.804.567-.145.1-.486.297-.711.398-1.285.554-1.767.57-2.332.612-.12.009-.49 0-1.808-.15-.571-.038-1.41-.169-1.916-.068-1.315.248-2.817 1.817-3.051 3.863l-.005.05c-.013.093.107.085.158.063l.021-.016c.286-.156.388-.303.52-.528.105-.173.447-.583.804-.91.987-.92 1.915-1.146 2.842-1.284.928-.139 1.84-.131 2.056-.092.23.033.34.141.357.356.005.113-.09.16-.242.231-.149.067-.314.142-.302.335.008.121.328.374 1.225.273zM31.627 17.041c-.277-.11-.32-.255-.242-.613.076-.36.106-.515-.073-.562-.152-.037-.366.047-.553.269-.188.226-.472.512-.553.759-.098.302.298.256.017.755-.464.827-.57 1.003-.78 1.594-.207.595-.352.692-.47.877-.12.184.169.197.522.088.38-.122.395.319.264.596-.11.234-.012.319.285.083.299-.23-.154-.382-.038-1.082.111-.642.243-.99.634-1.62.332-.549.63-.922 1.188-.716.238.087.127-.302-.201-.428z",
    fill: "#4F4B4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M29.137 57.349c15.54 0 28.137-12.614 28.137-28.175C57.274 13.614 44.676 1 29.137 1 13.597 1 1 13.614 1 29.174 1 44.734 13.597 57.35 29.137 57.35z",
    stroke: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLloydsLogo);
export default __webpack_public_path__ + "static/media/lloyds-logo.9aa504a3a6ccb46edfc3f157758f477a.svg";
export { ForwardRef as ReactComponent };